import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState } from '../../stores/types/types';
import * as SessionActions from '../../stores/actions/session';
import * as OpenTokActions from '../../stores/actions/opentok';
import { HELP_SUBMENU } from '../../stores/reducers/session';
import Link from '../general-components/link';
import * as ModalActions from '../../stores/actions/modal';
import { MODAL_TEMPLATES } from '../../stores/reducers/modal';
import { setSolutionCenterContentState } from '../../stores/actions/user-interface';
import { SolutionCenterViews } from '../../types/solution-center';

interface HelpMenuProps {
	onClose: () => void;
}

export default function HelpMenu(props: HelpMenuProps) {
	const host = useSelector((state: GreenroomState) => state.SessionReducer.host);
	const showDebugUI = useSelector((state: GreenroomState) => state.OpenTokReducer.showDebugUI);

	const { onClose } = props;

	const dispatch = useDispatch();

	const openSolutionCenter = () => {
		dispatch(setSolutionCenterContentState(null, SolutionCenterViews.Home));
		onClose();
	};

	const setSubmenu = (submenu: string) => {
		dispatch(SessionActions.setActiveHelpSubmenu(submenu));
	};

	const showProductTour = () => {
		dispatch(ModalActions.setModalState({
			modalOpen: true,
			modalTemplate: MODAL_TEMPLATES.PRODUCT_TOUR,
		}));
		onClose();
	};

	const showOpenTokDebugUI = () => {
		dispatch(OpenTokActions.setShowDebugUI(!showDebugUI));
		onClose();
	};

	return (
		<div className="help-menu">
			<button onClick={showProductTour} className='select-option'>
				Product Tour
			</button>
			<button onClick={openSolutionCenter} className='select-option'>
				Solution Center
			</button>
			<Link
				title='Brandlive Support'
				url='https://support.brandlive.com/hc/en-us/requests/new'
				customClass='link-button select-option'
				onClick={onClose}
			/>
			<Link
				title='Release Notes'
				url='https://support.brandlive.com/hc/en-us/sections/30994252634651-Release-Library'
				customClass='link-button select-option'
				onClick={onClose}
			/>
			<button onClick={() => setSubmenu(HELP_SUBMENU.KEYBOARD_SHORTCUTS)} className='select-option'>
				Keyboard Shortcuts
			</button>
			{host && <button onClick={showOpenTokDebugUI} className='select-option'>Troubleshoot Video</button>}
		</div>
	);
}
